import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { VersionShare, VersionShareListItemMenuClick } from '@core/models/version-share.model';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

@Component({
    selector: 'core-version-shares-status-list',
    templateUrl: './status-list.component.html',
    styleUrls: ['./status-list.component.scss']
})
export class CoreVersionSharesStatusListComponent implements OnInit, OnChanges {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 3;

    public readonly APPROVAL_PENDING = 0;
    public readonly APPROVAL_APPROVED = 1;
    public readonly APPROVAL_REJECTED = 2;

    @Input() versionShareBubbles: Array<VersionShare>;
    @Input() menu: Array<ThreeDotsMenuItem> = []; // TODO
    @Output() menuClick = new EventEmitter<VersionShareListItemMenuClick>();

    public status: number = this.STATUS_LOADING;

    constructor() {}

    ngOnInit() {
        if(this.versionShareBubbles != null)
            this.status = this.STATUS_DONE;
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.versionShareBubbles && changes.versionShareBubbles.currentValue != null){
            // console.debug(" the shares in status list ",this.versionShareBubbles);
            this.status = this.STATUS_DONE;
        }
    }

    onMenuItemClick(shareMenuItem: VersionShareListItemMenuClick){
        this.menuClick.emit(shareMenuItem);
    }


}
